import { FC } from 'react';
import {
  Button,
  Spacer,
  TextTitle,
  TextBody,
  Grid,
  GridCell,
  Input,
  Select,
  SelectOption,
  Image,
  Stack,
  Tag,
  logos,
} from '@pypestream/design-system';
// import { TranslationComponent } from '@pypestream/translations';

import { GenericModal, GenericModalProps } from '..';

export type ConnectAspModalProps = GenericModalProps & {
  type?: 'connect' | 'edit';
};

export const ConnectAspModal: FC<ConnectAspModalProps> = ({
  type = 'connect',
  modalRef,
  onClose,
}) => {
  const isEdit = type === 'edit';

  return (
    <GenericModal
      test-id="load-as-draft-modal"
      modalRef={modalRef}
      onClose={onClose}
      size="large"
    >
      <TextTitle size="small" textAlign="center">
        {isEdit ? 'Edit' : 'Connect an'} agent platform
      </TextTitle>
      <Spacer size="small" />
      <TextBody variant="secondary" textAlign="center">
        {isEdit
          ? `
        Edit an existing Agent Platform connection. Update the platform type, connection name or connection fields
        `
          : `
         Configure a new Agent Platform connection. Select your platform,
        give the integration a clear name, and enter the required connection
        fields.
        `}
      </TextBody>
      <Spacer size="xlarge" />

      <Grid>
        {isEdit && (
          <GridCell xsmall="12">
            <TextBody size="small">Solutions Using This Connection:</TextBody>
            <Spacer size="2xsmall" />
            <Stack>
              {['CustomerAcquisitionSolution', 'WifiFix', 'New Products'].map(
                (solution, i) => (
                  <Tag
                    key={i}
                    size="small"
                    minimal
                    // variant=${type === 'live' ? 'success' : 'default'}
                  >
                    {solution}
                  </Tag>
                )
              )}
            </Stack>
          </GridCell>
        )}
        <GridCell xsmall="12">
          <TextBody size="small">Connection Name</TextBody>
          <Spacer size="2xsmall" />
          <Input value="ADTContact Center" variant="outlined" />
        </GridCell>
        <GridCell xsmall="12">
          <TextBody size="small">Platform</TextBody>
          <Spacer size="2xsmall" />
          <Select
            disabled
            variant="outlined"
            value="contact-center"
            placeholder="Select a platform"
          >
            <Image
              src={logos.contactCenter}
              width="24px"
              height="24px"
              slot="prefix"
            />
            <SelectOption value="contact-center">
              <Image
                src={logos.contactCenter}
                width="24px"
                height="24px"
                slot="prefix"
              />
              Contact Center
            </SelectOption>
          </Select>
        </GridCell>
        <GridCell xsmall="12" medium="6">
          <TextBody size="small">Account_id</TextBody>
          <Spacer size="2xsmall" />
          <Input value="ADTContact Center" variant="outlined" />
        </GridCell>
        <GridCell xsmall="12" medium="6">
          <TextBody size="small">Inbox_id</TextBody>
          <Spacer size="2xsmall" />
          <Input value="ADTContact Center" variant="outlined" />
        </GridCell>
      </Grid>

      <Stack slot="footer" gutter="xsmall" justifyContent="end">
        <Button size="large" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="large" onClick={onClose}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
      </Stack>
    </GenericModal>
  );
};
